import { Outlet } from 'react-router-dom'

import CustomFieldsSettings from 'modules/documents/components/Settings/CustomFields'

const CustomFieldsFolderSettingsPage = () => (
  <>
    <Outlet />
    <CustomFieldsSettings />
  </>
)

export default CustomFieldsFolderSettingsPage
